<template>
    <el-drawer :visible.sync="outDrawer" size="100%" id="el-drawer__title" :show-close="false">
        <div class="flex space-between aic pr20 bb">
            <header-time></header-time>
            <el-row>
                <el-button plain @click="hide"><span class="pl20 pr20">关闭</span></el-button>
            </el-row>
        </div>
        <div class="prescription">
            <div class="bg_fff pt10 pb10 pl15 pr15 flex space-between">
                <el-row>
                    <el-button v-if="type ==='CHECK'" type="primary" plain size="medium"
                               @click="doAction('开检查单')">开检查单
                    </el-button>
                    <el-button v-if="type ==='INSPECT'" type="primary" plain size="medium"
                               @click="doAction('开检验单')">开检验单
                    </el-button>
                </el-row>
                <el-row>
                    <el-button type="primary" size="medium" @click="doAction('确定开单')">确定开单</el-button>
                </el-row>
            </div>
            <div class="mt20 flex jcb" >
                <div class="width100 bg_fff">
                    <el-tabs v-model="activeTab" type="card" closable
                             class="pl20 pr20"
                             @tab-remove="removeTab" @tab-click="tabChange">
                        <el-tab-pane
                                v-for="(item, index) in tabsList"
                                :key="item.name"
                                :label="item.title"
                                :name="item.name">
                        </el-tab-pane>
                    </el-tabs>
                    <div class="pl20 pr20 color_333">
                        <div class="flex column relative overflow-y-auto"
                             :style="{height:clientHeight-210+'px'}">
                            <h3 class="fs20 bold flex jcc relative">{{docInfo.hosName}}</h3>
                            <p>
                                <span class="sign signC" v-if="subStatus">已提交</span>
                                <span class="sign" v-else>未提交</span>
                            </p>
                            <p class="mt40 pt16 fs14">
                                姓名：{{orderInfo.compatName}}
                                <span class="pl30">性别：{{orderInfo.compatGender|sexFilter}}</span>
                                <span class="pl30">年龄：{{orderInfo.compatAge}}岁</span>
                                <span class="pl30">就诊科室：{{orderInfo.bookDeptName}}</span>
                                <span class="pl30">开单医生：{{orderInfo.bookDocName}}</span>
                                <span class="pl30">开单日期：{{currDate}}</span>
                            </p>
                            <ul class="mb15 pt10 pb10 fs14 width70">
                                <li v-if="type ==='INSPECT'" class="flex">
                                    <p class="flex0 info-label pt5">标<span class="pl25">本：</span></p>
                                    <el-input size="mini"
                                              v-model="currenInfo.sampleType">
                                    </el-input>
                                </li>
                                <li class="flex aic mt15">
                                    <span class="flex0 info-label pt5">{{typeName}}类型：</span>
                                    <el-select v-model="currenInfo.inspectionTypeName"
                                               :placeholder="`请选择${typeName}类型`"
                                               @change="onSelectedType"
                                               size="mini">
                                        <el-option
                                                v-for="item in typeList"
                                                :key="item.id"
                                                :label="item.inspectTypeName"
                                                :value="item.inspectTypeName">
                                        </el-option>
                                    </el-select>
                                </li>
                                <li class="flex mt15">
                                    <span class="flex0 info-label pt5">{{typeName}}项目：</span>
                                    <div class="flex column">
                                        <div v-for="(num,index) in currenInfo.itemIdList"
                                             :key="`${num}${index}`"
                                             class="flex aic jcc" :class="{'mt10': index>0}">
                                            <el-select v-model="currenInfo.itemIdList[index]"
                                                       :placeholder="`请选择${typeName}项目`"
                                                       size="mini"
                                                       :disabled="currenInfo.inspectionTypeName.length === 0"
                                                       @change="spectList(index)">
                                                <el-option v-for="(item, indexs) in inspectList"
                                                           :key="item.id"
                                                           :label="item.inspectName"
                                                           :value="item.id"
                                                ></el-option>
                                            </el-select>
                                            <p class="pointer pl10 fs22">
                                                <span class="color_main"
                                                      v-if="index === 0"
                                                      @click="addItem">+</span>
                                                <span v-else class="color_red"
                                                      @click="removeItem(index)">×</span>
                                            </p>
                                        </div>
                                    </div>

                                </li>
                                <li class="flex mt15" style="height: 30px;">
                                    <span class="flex0 info-label pt5">初步诊断：</span>
                                    <el-autocomplete
                                            class="flex1"
                                            size="mini"
                                            type="textarea"
                                            style="z-index: 2006"
                                            autosize
                                            placeholder="按诊断名称或拼音首字母搜索"
                                            v-model="diagnosis"
                                            @blur="blurDiagnosis"
                                            :fetch-suggestions="fetchDiagnosis"
                                            @select="(item)=>{selectDiagnose(item)}"
                                            @keydown.native="deleteDiagnosis"
                                    ></el-autocomplete>
                                </li>
                                <li class="flex column mt15">
                                    <span class="flex0 info-label pt5">主诉及症状</span>
                                    <el-input
                                            type="textarea"
                                            :autosize="{ minRows: 5}"
                                            placeholder="可不填"
                                            class="pt5"
                                            v-model="currenInfo.symptom">
                                    </el-input>
                                </li>
                                <li class="flex column mt15">
                                    <span class="flex0 info-label pt5">备注</span>
                                    <el-input
                                            type="textarea"
                                            :autosize="{ minRows: 5}"
                                            placeholder="可不填"
                                            class="pt5"
                                            v-model="currenInfo.remark">
                                    </el-input>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
    import {tokenCache} from "../lib/cache/Token"
    import {isEmpty, isContains, timeFormat} from "../lib/utils";
    import {onlineService} from "../lib/service/online";
    import HeaderTime from "../components/common/header-time";
    import {sexFilter} from "../lib/filters";

    export default {
        name: "Inspection",
        props:{
            inspectionType: String,
            orderDetail: Object, //订单信息
        },
        data () {
            return {
                type: '', //检验检查类型 INSPECT-检验 CHECK-检查
                typeName: '', //
                outDrawer: false,
                typeList: [],  ////检验检查类型列表
                recipeInfo: {}, //处方所需参数
                orderInfo: {}, //原订单信息
                activeTab: '',
                tabIndex: 1,
                showTabIndex: 1,
                tabsList: [],
                inspectList: [], //项目列表
                allInfo: {
                    1: {
                        inspectionTypeName: '', //检验或者检查类型
                        inspectionTypeId: '', //检验或者检查类型Id
                        inspectionItemName: '', //检验或者检查项目(传一个逗号分隔的字符串)
                        itemIdList:[''], //项目列表
                        itemNameList: [''], //项目列表
                        diagnosis: '', //初步诊断
                        sampleType: '', //标本种类，检验单必传(传一个逗号分隔的字符串)
                        symptom: '', //主诉及症状
                        remark: '', //备注
                        subStatus: false,
                    }
                },

                diagnosis: "",
                diagnosisTemp: "",
                subStatus: false,
                currenInfo: {}, //当前检查检验方内容
                endInspection: false,//是否结束了续方，
            };
        },
        computed: {
            currDate() {
                const tDate = new Date()
                return timeFormat(tDate, "%Y/%m/%d")
            },
            clientHeight() {
                return (document.documentElement.clientHeight - 1 || document.body.clientHeight - 1)
            },
        },
        filters: {sexFilter},
        components: { HeaderTime },
        watch: {
            inspectionType:{
                async handler(newV) {
                    // console.log('【类型发生变化】', newV)
                    if(!newV) return
                    this.type = newV
                    this.typeName = newV === 'CHECK'? '检查':'检验'
                    this.currenInfo = this.allInfo[this.tabIndex]
                    await this.init()
                },
                immediate: true
            },
            orderDetail:{
                handler(newV) {
                    this.orderInfo = newV
                },
                immediate: true
            },
            activeTab: {
              handler(newV){
                  this.showTabIndex = Number(newV.slice(3,4))
              }
            },
            showTabIndex: {
                async handler(newV) {
                    this.currenInfo = this.allInfo[newV]
                    this.diagnosis = this.allInfo[newV].diagnosis
                    this.diagnosisTemp = this.allInfo[newV].diagnosis
                    this.inspectList = await onlineService.inspectList(
                        this.orderInfo.hosId,
                        this.currenInfo.inspectionTypeId
                    )
                }
            },
            allInfo:{
                handler(newV) {
                    // console.log('【列表发生了变化】', newV)
                    this.currenInfo = this.allInfo[this.showTabIndex]
                },
                deep: true
            }
        },
        methods: {
            async init(){
                console.log('【init】')
                this.subStatus = false
                this.activeTab = this.type === 'CHECK' ? '检查单1' : '检验单1'
                this.tabsList = this.type === 'CHECK' ?
                    [{title: '检查单1', name: '检查单1',}] : [{title: '检验单1', name: '检验单1',}]
                await this.getTypeList()
            },

            deleteDiagnosis(e) {
                if (e.keyCode == 8) {
                    const o = this.diagnosis.split('，')
                    o.splice(o.length - 2, 2)
                    let n = o.length >= 1 ? o.join("，") + '，' : o.join("，")
                    this.diagnosis = this.diagnosisTemp = n
                }
            },

            //获取检查类型列表
            async getTypeList() {
                if (!this.type) return
                let list = await onlineService.typeList(this.orderInfo.hosId, this.type)
                if (list.length>0){
                    this.typeList = list
                }
            },

            show(){
                this.outDrawer = true
            },
            hide(){
                let empty = true
                let obj = this.allInfo
                Object.keys(obj).forEach(function(key){
                    console.log(key,obj[key]);
                    let info = obj[key]
                    if (info.diagnosis || info.inspectionItemName || info.remark ||info.sampleType ||info.symptom ||info.inspectionTypeName){
                        empty = false
                    }
                });
                if (!empty && !this.subStatus){
                    this.$confirm(`您开具的${this.typeName}单还未提交，确定关闭开后数据将不会保存？`, '关闭提示', {
                        confirmButtonText: '确定关闭',
                        cancelButtonText: '暂不关闭',
                        type: 'warning'
                    }).then(() => {
                        this.clean()
                        this.outDrawer = false
                    }).catch(() => {})
                } else {
                    this.clean()
                    this.outDrawer = false
                }
            },
            clean(){
                this.tabIndex = 1
                this.activeTab = this.type === 'CHECK' ? '检查单1' : '检验单1'
                this.tabsList = this.type === 'CHECK' ?
                    [{title: '检查单1', name: '检查单1',}] : [{title: '检验单1', name: '检验单1',}]
                this.currenInfo = {}
                this.diagnosis = ""
                this.diagnosisTemp= ""
                this.allInfo = {
                    1:{
                        inspectionTypeName: '', //检验或者检查类型
                        inspectionItemName: '', //检验或者检查项目(传一个逗号分隔的字符串)
                        itemIdList:[''], //项目列表
                        itemNameList: [''], //项目列表
                        diagnosis: '', //初步诊断
                        sampleType: '', //标本种类，检验单必传(传一个逗号分隔的字符串)
                        symptom: '', //主诉及症状
                        remark: '', //备注
                        subStatus: false
                    }
                }
                this.endInspection = false
            },
            //增加项目
            addItem(){
                this.currenInfo.itemIdList.push('');
            },
            //移除项目
            removeItem(index){
                this.currenInfo.itemIdList.splice(index,1);
            },

            //预约项目选择事件
            spectList(index){
                if (isContains(this.currenInfo.itemIdList,this.currenInfo.itemIdList[index])){
                    this.$message({
                        message: '该项目已被选择。',
                        type: 'error'
                    });
                    this.allInfo[this.showTabIndex].itemIdList[index]= ""
                } else {
                    let name = ''
                    let nameList = []
                    this.currenInfo.itemIdList.forEach((x, index) =>{
                        this.inspectList.forEach((item)=>{
                            if (item.id === x){
                                let tip = index < this.currenInfo.itemIdList.length-1? '，' : ''
                                name += (item.inspectName + tip)
                                nameList.push(item.inspectName)
                            }
                        })
                    })
                    this.allInfo[this.showTabIndex].itemNameList = nameList
                    this.allInfo[this.showTabIndex].inspectionItemName = name
                    this.allInfo[this.showTabIndex].sampleType = name

                }
            },

            //选择检验类型之后
            async onSelectedType(event) {
                let value = {}
                this.typeList.forEach(item=>{
                    if (item.inspectTypeName === event){
                        value = item
                    }
                })
                this.inspectList = await onlineService.inspectList(this.orderInfo.hosId, value.id)
                this.allInfo[this.showTabIndex].inspectionTypeId = value.id
                this.allInfo[this.showTabIndex].itemIdList = ['']
                this.allInfo[this.showTabIndex].itemNameList = ['']
                this.allInfo[this.showTabIndex].inspectionItemName = ''
                this.allInfo[this.showTabIndex].sampleType = ''
            },

            //事件操作
            doAction(name, type) {
                const map = this.getActionMap();
                const action = [...map].find(r => r[0] === name);
                if (isEmpty(action)) this.$message.error(`未定义 ${name} 操作!`);
                else {
                    action[1](name, type);
                }
            },
            //事件
            getActionMap() {
                return new Map([
                    ['开检查单', () => {
                        this.addTab('检查单')
                    }],
                    ['开检验单', () => {
                        this.addTab('检验单')
                    }],
                    ['确定开单', () => {
                        this.submit()
                    }],
                ])
            },

            //选择诊断
            selectDiagnose(item) {
                console.log('之前的诊断===', this.diagnosisTemp)
                console.log('选择后的诊断===', item)
                if (this.diagnosisTemp !== '') {
                    let n = this.diagnosisTemp.split('，').length
                    //限制诊断数量
                    if (n < 200) {
                        this.diagnosisTemp = this.diagnosisTemp + item.diagnosis + '，'
                    } else {
                        this.$message.error('输入诊断数量不能超过5个！')
                    }
                } else {
                    this.diagnosisTemp = this.diagnosis = this.diagnosis + '，'
                }
                this.diagnosis = this.diagnosisTemp
                this.allInfo[this.showTabIndex].diagnosis = this.diagnosis
            },
            /**
             * 新增tab标签
             * @param tabName
             */
            addTab(tabName) {
                const index = ++ this.tabIndex
                let newTabName = index + '';
                this.showTabIndex = index
                this.tabsList.push({
                    title: tabName + newTabName,
                    name: tabName + newTabName,
                });
                this.activeTab = tabName + newTabName;
                this.allInfo[index] = {
                    inspectionTypeName: '', //检验或者检查类型
                    inspectionItemName: '', //检验或者检查项目(传一个逗号分隔的字符串)
                    itemIdList:[''], //项目列表
                    itemNameList: [''], //项目列表
                    diagnosis: '', //初步诊断
                    sampleType: '', //标本种类，检验单必传(传一个逗号分隔的字符串)
                    symptom: '', //主诉及症状
                    remark: '', //备注
                    subStatus: false
                }
                this.diagnosisTemp = '';
                this.subStatus = this.allInfo[index].subStatus = false
            },
            tabChange() {
                this.showTabIndex = Number(this.activeTab.slice(3))
                this.diagnosisTemp = '';
                this.subStatus = this.allInfo[this.showTabIndex].subStatus
            },
            //删除处方单
            removeTab(targetName) {
                if (this.tabsList.length <= 1) {
                    this.$message({
                        type: 'warning',
                        message: `请至少保留一个${this.type === 'CHECK '? '检查':'检验'}单！`
                    })
                    return
                }
                this.$confirm(`是否确定删除【${targetName}】,删除后不可恢复，仍要继续该操作？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let tabs = this.tabsList;
                    let activeName = this.activeTab;
                    if (activeName === targetName) {
                        tabs.forEach((tab, index) => {
                            if (tab.name === targetName) {
                                let nextTab = tabs[index + 1] || tabs[index - 1];
                                nextTab && (activeName = nextTab.name)
                            }
                        });
                    }
                    this.activeTab = activeName;
                    this.tabsList = tabs.filter(tab => tab.name !== targetName);
                    let index = targetName.slice(3,4)
                    delete this.allInfo[index]

                    this.diagnosisTemp = ''
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })
            },

            //检查 检查检验方
            async checkError() {
                if (this.allInfo[this.showTabIndex].subStatus) {
                    this.$message.error('该处方单已提交，不可重新提交！')
                    return false
                }

                let curr = this.allInfo[this.showTabIndex]
                if (!curr.inspectionTypeName){
                    this.$message.error(`请选择${this.typeName}类型`)
                    return false
                }else if (!curr.inspectionItemName){
                    this.$message.error(`请选择${this.typeName}项目`)
                    return false
                } else if (!curr.diagnosis){
                    this.$message.error('初步诊断不能为空')
                    return false
                } else if (this.type === 'INSPECT' && !curr.sampleType){
                    this.$message.error('标本不能为空')
                    return false
                }
                return true

            },
            //提交 检查检验方
            async submit() {
                let check = await this.checkError()
                if (check) {
                    let dia = this.currenInfo.diagnosis
                    let diagnosis = dia.charAt(dia.length - 1) === ';' ?
                        dia.substring(0, dia.length - 1) : dia;//去除最后一个逗号

                    let curr = this.allInfo[this.showTabIndex]
                    let obj = await onlineService.openInspection({
                        type : this.type,
                        inspectionTypeName: curr.inspectionTypeName,
                        inspectionItemName: curr.inspectionItemName,
                        commpatIdcard: this.orderInfo.compatIdcard,
                        commpatName: this.orderInfo.compatName,
                        commpatPhone: this.orderInfo.compatMobile,
                        patId:  this.orderInfo.patId,
                        diagnosis,
                        sampleType: curr.sampleType,
                        symptom: curr.symptom,
                        remark: curr.remark,
                        hosId: this.docInfo.hosId,
                        module: 'ONLINE_OUTPATIENT'
                    })
                    if (Object.values(obj).length>0) {
                        this.$message({
                            type: 'success',
                            message: `开${this.typeName}单成功！`
                        });
                        this.subStatus = this.allInfo[this.showTabIndex].subStatus = true
                    }
                }
            },

            blurDiagnosis() {
                let name = this.diagnosis
                if (name.substr(name.length - 1, 1) === '，') return
                let list = this.diagnosis.split('，')
                let re = list.slice(0, list.length - 1)
                let res = re.length >= 1 ? re.join("，") + '，' : re.join("，")
                this.diagnosis = res
                this.diagnosisTemp = this.diagnosis
            },
            async fetchDiagnosis(queryString, cb) {
                let newQuery = queryString + '，'
                if (newQuery === this.diagnosisTemp) {
                    queryString = newQuery
                    this.diagnosis = this.diagnosisTemp
                }
                const index = queryString.lastIndexOf('，')
                const key = queryString.substring(index + 1, queryString.length);
                const options = {
                    diagnosis: key,
                    token: tokenCache.get(),
                }
                let {code, list} = await this.$http("smarthos.recipe.diagnosis.list", options)
                if (code == '0') {
                    for (let i of list) {
                        i.value = i.diagnosis; //必须绑定value值作为显示数据
                    }
                    cb(list);
                }
            },
        }
    };
</script>

<style lang="scss">
    #el-drawer__title{
        padding: 0!important;
        margin: 0!important;
    }

    .prescription {
        .el-form {
            padding-top: 22px;
            border-top: 1px solid #f5f5f5;
        }
        .el-table {
            margin-top: 15px;
        }
        .pagination-wrapper {
            padding: 20px 0;
        }
        .el-table .cell {
            max-height: 69px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
        }
    }

    .el-table__header-wrapper {
        .cell {
            label.el-checkbox {
                display: none !important;
            }
        }
    }

    .sign {
        width: 65px;
        height: 25px;
        position: absolute;
        top: 15px;
        left: 70px;
        color: white;
        background-color: red;
        border-radius: 2px;
        text-align: center;
        transform: rotateZ(-30deg);
    }

    .signC {
        background-color: #ffffff;
        border: 1px solid #58A4FA;
        color: #58A4FA;
    }

    .info-label {
        font-size: 14px;
        color: #333333;
    }

    .info-item {
        font-size: 14px;
        color: #666666;
        margin-right: 60px;
        border-bottom: 1px solid #333333;
        padding: 0 10px;
    }

</style>
